import { IContextSwitcher } from 'redux/initialStates/contextSwitcher/contextSwitcher';
import { RootState } from '../../store';

export const selectContextSwitcherState = (state: RootState): IContextSwitcher => state.contextSwitcher;
